import { Box, IconButton, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { GetCopyTableRowWords } from 'components/ReportElement'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts'
import HC_exporting from 'highcharts/modules/exporting'

HC_exporting(Highcharts)

interface Props {
  row: any
  schoolName: string
  surveyType: string
}

const CopyRowButton: React.FC<Props> = ({ row, schoolName, surveyType }) => {
  const copyRef = React.useRef<HTMLDivElement | null>()
  const canvasRef = React.useRef<HTMLDivElement | null>()
  const [imageSrc, setImageSrc] = useState('')
  const title = GetCopyTableRowWords(row.current[0], schoolName, surveyType)

  const chartRef = useRef<HighchartsReact.RefObject>(null)

  useEffect(() => {
    if (chartRef.current && canvasRef.current) {
      const chart = chartRef.current.chart
      const series = chart.series[0]
      const svg = chart.getSVG()
      const parser = new DOMParser()
      const svgElem = parser.parseFromString(svg, 'image/svg+xml')
        .documentElement as HTMLCanvasElement
      // serialize the element to String
      const s = new XMLSerializer().serializeToString(svgElem)
      let b64 = 'data:image/svg+xml;base64,'
      b64 += btoa(unescape(encodeURIComponent(s)))

      const canvas = canvasRef.current.getElementsByTagName(
        'canvas'
      )[0] as HTMLCanvasElement
      const ctx = canvas.getContext('2d')
      if (ctx) {
        const image = new Image()
        image.onload = () => {
          ctx.fillStyle = 'white'
          ctx.fillRect(0, 0, canvas.width, canvas.height)
          ctx.drawImage(image, 0, 0)
          ctx.fillStyle = 'black'
          ctx.textAlign = 'center'
          ctx.font = '30px Arial'
          //@ts-ignore Highchart.Series missing center def?
          const numberY = series.center[1] + chart.plotTop - 15
          ctx.fillText(row.current[0], 250, numberY)
          ctx.font = '20px Arial'
          //@ts-ignore Highchart.Series missing center def?
          const labelY = series.center[1] + chart.plotTop + 15
          ctx.fillText('Rated positively', 250, labelY)
          ctx.font = '16px Arial'
          ctx.fillText('www.youthtruth.org', 250, 440)
          setImageSrc(canvas.toDataURL())
        }
        image.src = b64
      }
    }
  }, [chartRef, canvasRef, row])

  const options = {
    exporting: {
      enabled: false,
      allowHTML: true,
    },
    title: {
      text: row.category,
      useHTML: true,
    },
    chart: {
      type: 'pie',
      width: 500,
      height: 400,
      custom: {},
    },
    plotOptions: {
      series: {
        innerSize: '70%',
        dataLabels: {
          enabled: false,
        },
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        data: [
          {
            name: row.category,
            y: parseFloat(row.current[0]),
            color: '#245971',
          },
          {
            name: row.category,
            y: 100 - parseFloat(row.current[0]),
            color: '#CFCFCF',
          },
        ],
      },
    ],
  }

  const handleCopy = () => {
    if (copyRef.current) {
      const text = copyRef.current.innerHTML
      const blob = new Blob([text], { type: 'text/html' })
      const item = new ClipboardItem({ 'text/html': blob })
      navigator.clipboard.write([item])
    }
  }

  return (
    <>
      <Box sx={{ whiteSpace: 'nowrap' }}>
        <IconButton
          color="primary"
          size="small"
          aria-label="Copy"
          onClick={() => handleCopy()}
        >
          <ContentCopyIcon />
        </IconButton>
      </Box>
      <Box hidden ref={canvasRef}>
        <canvas width="500px" height="500px" />
      </Box>
      <Box hidden ref={copyRef}>
        <Typography>{title}</Typography>
        <Box dangerouslySetInnerHTML={{ __html: row.category || '' }} />
        <Box sx={{ width: '500px', height: '500px', position: 'relative' }}>
          <img src={imageSrc} width="100%" />
        </Box>
      </Box>
      <Box
        hidden
        sx={{ width: '500px', height: '500px', position: 'relative' }}
      >
        <HighchartsReact
          ref={chartRef}
          highcharts={Highcharts}
          options={options}
        />
      </Box>
    </>
  )
}

export default CopyRowButton
